import { useLocalStorage } from "@uidotdev/usehooks";

interface UserPreferences {
  lastSearchType?: number;
  lastCalculatorTab?: string;
}

const DEFAULT_PREFERENCES: UserPreferences = {
  lastSearchType: 0,
};

export function useUserLocalPreferences() {
  const [preferences, setPreferences] = useLocalStorage<UserPreferences>("userPreferences", DEFAULT_PREFERENCES);

  const updatePreference = <K extends keyof UserPreferences>(key: K, value: UserPreferences[K]) => {
    setPreferences((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return {
    preferences,
    updatePreference,
  };
}
